export const CustomerEndPoints = {
  createNewCustomer: "add-customer",
  deleteCustomer: "delete-customer",
  editCustomer: "update-customer",
  getCustomers: "get-all-customers",
  getCustomer: "get-customer-by-id",
  getCustomerByEmail: "get-customer-by-email",
  getPresignedUrl: "get-presigned-url",
};

export const productEndPoints = {
  createNewProduct: "products/",
  editProduct: "products/",
  getProducts: "products/",
};

export const endpoints = {
  addUser: "add-user",
  deleteUser: "delete-user",
  getUsers: "get-users",
  getUserByEmail: "get-user",
};

export const orderEndpoints = {
  //cancelOrder: "cancel-order",
  getOrder: "get-order-details-by-id",
  editOrder: "change-order-status",
  createOrder: "create-order",
  getOrders: (emailId: string) => `get-orders/${emailId}`,
};

export const productInventoryEndPoints = {
  productInventory: "product-inventory",
};

export const shipmentEndpoints = {
  getOrderByStatus: "get-order-by-status",
  updateShipment: "update-shipment",
};

export const cartEndpoints = {
  getCartByCustomerId: "cart",
  updateCartByCustomerId: "cart",
};

export const inventoryEndPoints = {
  lockInventory: "lock-inventory",
  unlockInventory: "unlock-inventory",
};

export const orderPaymentEndPoints = {
  updateOrderPayment: "orders",
  getOrderPayment: "orders",
};

export const invoiceEndPoints = {
  downloadInvoice: "download-invoice",
  getInvoiceDetails: "get-invoice",
  updateInvoice: "update-invoice",
};

export const ledgerEndPoints = {
  download: "ledgers/download",
  base: "ledgers",
};
